import React from "react";
import ReactDOM from "react-dom/client"; // Import the new createRoot API
import App from "./App";

window.ReactApp = (element) => {
  const root = ReactDOM.createRoot(element); // Correct way to initialize React 18
  root.render(<App />);
};